import { Popover } from "antd";
import { useState } from "react";
import { FilterPanelContent } from "./FilterPanelContent.tsx";
import "./FilterPanel.scss";
import type { DataTableFilter } from "../../types/dataTableFilter.ts";

type FilterPanelProps = {
  filters: DataTableFilter[];
  onChangeFilters: (filterKey: string, values: any) => void;
  currentFilter: Record<string, any>;
};
export const FilterPanel = ({ filters, onChangeFilters, currentFilter }: FilterPanelProps) => {
  const [filtersOpen, setFiltersOpen] = useState(false);

  return (
    <div>
      <Popover
        styles={{ body: { padding: "16px" } }}
        arrow={false}
        trigger="click"
        placement="bottomLeft"
        open={filtersOpen}
        onOpenChange={setFiltersOpen}
        content={<FilterPanelContent filters={filters} onChangeFilters={onChangeFilters} currentFilter={currentFilter} />}
      >
        <div>
          <i className="fa-solid fa-sliders gear-icon"></i>
        </div>
      </Popover>
    </div>
  );
};
